export default __webpack_public_path__ + "static/media/Logo.a941b7cc.svg";